import { render } from "./PinsComponent.vue?vue&type=template&id=38d64ed2&scoped=true"
import script from "./PinsComponent.vue?vue&type=script&lang=js"
export * from "./PinsComponent.vue?vue&type=script&lang=js"

import "./PinsComponent.vue?vue&type=style&index=0&id=38d64ed2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d64ed2"]])

export default __exports__